import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AncButtonDirective, AncDialogComponent } from '@libs/common-interceptor';
import { IdleWarningModalComponent } from './idle-warning-modal/idle-warning-modal.component';

@NgModule({
    declarations: [IdleWarningModalComponent],
    imports: [
        CommonModule,
        TranslateModule,
        AncDialogComponent,
        AncButtonDirective
    ],
    exports: [IdleWarningModalComponent]
})
export class IdleTimeoutModule {}
